import React from 'react';
import { Container as Wrapper } from './Container.styles';

const Container = ({ children, ...rest }) => <Wrapper {...rest}>{children}</Wrapper>;

export default Container;
